export enum CreditCategory {
  PRODUCTION = 'PRODUCTION',
  LOGISTICS = 'LOGISTICS',
  COMMERCIAL = 'COMMERCIAL',
  MARKETING = 'MARKETING',
  PREORDER = 'PREORDER',
  BILLING = 'BILLING',
  REFERRAL_SPONSOR = 'REFERRAL_SPONSOR',
  REFERRAL_REFEREE = 'REFERRAL_REFEREE',
}
